// Request states
export const FETCH_MAILER_REQUEST = 'FETCH_MAILER_REQUEST';
export const FETCH_MAILER_SUCCESS = 'FETCH_MAILER_SUCCESS';
export const FETCH_MAILER_ERROR = 'FETCH_MAILER_ERROR';

// User reporting emailer details
export const FETCH_USER_REPORTING_EMAILER_DETAILS_REQUEST = 'FETCH_USER_REPORTING_EMAILER_DETAILS_REQUEST';
export const FETCH_USER_REPORTING_EMAILER_DETAILS_SUCCESS = 'FETCH_USER_REPORTING_EMAILER_DETAILS_SUCCESS';
export const FETCH_USER_REPORTING_EMAILER_DETAILS_ERROR = 'FETCH_USER_REPORTING_EMAILER_DETAILS_ERROR';

// All user reporting emailer details
export const FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_REQUEST = 'FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_REQUEST';
export const FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_SUCCESS = 'FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_SUCCESS';
export const FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_ERROR = 'FETCH_ALL_USER_REPORTING_EMAILER_DETAILS_ERROR';

// Measures
export const FETCH_ALL_MEASURES_REQUEST = 'FETCH_ALL_MEASURES_REQUEST';
export const FETCH_ALL_MEASURES_SUCCESS = 'FETCH_ALL_MEASURES_SUCCESS';
export const FETCH_ALL_MEASURES_ERROR = 'FETCH_ALL_MEASURES_ERROR';

// Metrics
export const FETCH_ALL_METRICS_REQUEST = 'FETCH_ALL_METRICS_REQUEST';
export const FETCH_ALL_METRICS_SUCCESS = 'FETCH_ALL_METRICS_SUCCESS';
export const FETCH_ALL_METRICS_ERROR = 'FETCH_ALL_METRICS_ERROR';

// Schedule report actions
export const CREATE_SCHEDULED_REPORT_REQUEST = 'CREATE_SCHEDULED_REPORT_REQUEST';
export const CREATE_SCHEDULED_REPORT_SUCCESS = 'CREATE_SCHEDULED_REPORT_SUCCESS';
export const CREATE_SCHEDULED_REPORT_ERROR = 'CREATE_SCHEDULED_REPORT_ERROR';

export const UPDATE_SCHEDULED_REPORT_REQUEST = 'UPDATE_SCHEDULED_REPORT_REQUEST';
export const UPDATE_SCHEDULED_REPORT_SUCCESS = 'UPDATE_SCHEDULED_REPORT_SUCCESS';
export const UPDATE_SCHEDULED_REPORT_ERROR = 'UPDATE_SCHEDULED_REPORT_ERROR';

export const DELETE_SCHEDULED_REPORT_REQUEST = 'DELETE_SCHEDULED_REPORT_REQUEST';
export const DELETE_SCHEDULED_REPORT_SUCCESS = 'DELETE_SCHEDULED_REPORT_SUCCESS';
export const DELETE_SCHEDULED_REPORT_ERROR = 'DELETE_SCHEDULED_REPORT_ERROR';

export const TOGGLE_REPORT_STATUS_REQUEST = 'TOGGLE_REPORT_STATUS_REQUEST';
export const TOGGLE_REPORT_STATUS_SUCCESS = 'TOGGLE_REPORT_STATUS_SUCCESS';
export const TOGGLE_REPORT_STATUS_ERROR = 'TOGGLE_REPORT_STATUS_ERROR';

// Reset actions
export const RESET_MAILER_DATA = 'RESET_MAILER_DATA';
export const RESET_MAILER_ERROR = 'RESET_MAILER_ERROR';

// Set selected data
export const SET_SELECTED_MAILER_DATA = 'SET_SELECTED_MAILER_DATA';
export const SET_MAILER_FORM_DATA = 'SET_MAILER_FORM_DATA';
